import {Navigate} from 'react-router';

const PrivateRoute = ({children}) => {
  const auth = window.sessionStorage.getItem('u_authenticated');
  return auth ? children : <Navigate to={'/'}/>;
};

export default PrivateRoute;
